const rshift = (a, b) => a >> b;
export default rshift;
